import * as React from "react";
import HelpedSelect from "../../general/helped_select";

export default function SafetySelect({ value, onChange, label, disabled = false }) {
  const options = {
    "No safety margin": { title: "No safety margin (0%)", margin: 0.0 },
    "10%": { title: "10%", margin: 0.1 },
    "20%": { title: "20%", margin: 0.2 },
    "25%": { title: "25%", margin: 0.25 },
    "40%": { title: "40%", margin: 0.4 },
  };

  return (
    <HelpedSelect
      valueKey="margin"
      optionKey="title"
      options={options}
      selected={value}
      onChange={onChange}
      label={label}
      info="Margin on safety on the constraint"
      disabled={disabled}
    />
  );
}
